// @flow
import {
  WAG_TAG_PLAN_PREMIUM,
  WAG_TAG_PLAN_BASIC,
} from '../../../../../constants';

export const FEATURE_DURABLE_TAG = {
  key: 'durable-tag',
  description: 'Durable laser-engraved ID tag',
};

export const FEATURE_ONLINE_PROFILE = {
  key: 'online-profile',
  description: 'Online dog profile synced to your dog\'s Wag! Tag',
};

export const FEATURE_LOST_DOG_GUIDE = {
  key: 'lost-dog-guide',
  description: 'Lost dog guide',
};

export const FEATURE_NO_BATTERIES = {
  key: 'no-batteries',
  description: 'No batteries necessary',
};

export const FEATURE_SEARCH_SUPPORT = {
  key: 'search',
  description: 'Local walker community search*',
};

export const FEATURE_24_7_SUPPORT = {
  key: 'support',
  description: 'Access to the Wag! 24/7 Support Center',
};

export const FEATURE_LOST_DOG_PLATFORMS = {
  key: 'lost-dog-platforms',
  description: 'Posts to lost dog platforms',
};

export const FEATURE_DIGITAL_FLYERS = {
  key: 'digital-flyers',
  description: 'Digital flyers',
};

export const plans = [
  {
    key: 'wag-tag-essential',
    title: 'Wag! Tag Essential',
    price: '$9.95',
    subTitle1: 'Plus shipping and handling',
    subTitle2: 'Standard pooch protection',
    features: [
      FEATURE_DURABLE_TAG,
      FEATURE_ONLINE_PROFILE,
      FEATURE_LOST_DOG_GUIDE,
      FEATURE_NO_BATTERIES,
    ],
    isFree: true, // Retail price given above, but still being offered for free
    buttonTestId: 'btn-order-wag-tag-essential',
    planType: WAG_TAG_PLAN_BASIC,
  },
  {
    key: 'wag-tag-complete',
    title: 'Wag! Tag Complete',
    price: '$49.95/year',
    subTitle1: 'Plus shipping and handling',
    subTitle2: 'Premium features for extra peace of mind',
    features: [
      FEATURE_DURABLE_TAG,
      FEATURE_ONLINE_PROFILE,
      FEATURE_LOST_DOG_GUIDE,
      FEATURE_NO_BATTERIES,
      FEATURE_24_7_SUPPORT,
      FEATURE_SEARCH_SUPPORT,
      FEATURE_LOST_DOG_PLATFORMS,
      FEATURE_DIGITAL_FLYERS,
    ],
    extraInfo: '*Only available in locations where Wag! services are provided. Search support limited to three times annually.',
    buttonTestId: 'btn-order-wag-tag-complete',
    planType: WAG_TAG_PLAN_PREMIUM,
    recommended: true,
  },
];
